import React, { useContext, useEffect } from 'react'
import MealsTable from './components/meals-table'
import DaysTable from './components/days-table'
import { DashboardContext } from '../../dashboard-context'
import styled from 'styled-components'

const Container = styled.div`
  padding: 32px 16px 200px 16px;
  margin: 0 auto;
  max-width: 1440px;
`;

const Templates = () => {
  const { openSnackbar } = useContext(DashboardContext)

  useEffect(() => {
    const pendingSnackbar = window.localStorage.getItem('pendingSnackbar')
    if (pendingSnackbar) {
      window.localStorage.removeItem('pendingSnackbar')
      openSnackbar(pendingSnackbar, false)
    }
  })

  return (
    <Container>
      <MealsTable />
      <DaysTable />
    </Container>
  )
}

export default Templates